module.exports = __webpack_public_path__ + "img/close.9c7b57ac.svg";